import { render, staticRenderFns } from "./NfcTransactionDetail.vue?vue&type=template&id=0ecf2456&scoped=true"
import script from "./NfcTransactionDetail.vue?vue&type=script&lang=js"
export * from "./NfcTransactionDetail.vue?vue&type=script&lang=js"
import style0 from "./NfcTransactionDetail.vue?vue&type=style&index=0&id=0ecf2456&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecf2456",
  null
  
)

export default component.exports